import React from 'react';
import { base, PICNumber, secondary } from '../../assets/strings/variables';

function Consult() {
  return (
    <section className='h-full grid grid-cols-1 px-6 sm:px-10 xl:px-0 max-w-[1200px] w-full py-14 sm:py-20 m-auto'>
      <div
        id='unanswered-question'
        className='text-center mx-auto md:w-[600px]'
      >
        <div className={`text-lg md:text-2xl text-[${secondary}] mb-10`}>
          Masih memiliki pertanyaan yang belum terjawab? Klik di sini untuk
          konsultasi.
        </div>
        <a href={`https://wa.me/${PICNumber}`} target='_blank' rel='noreferrer'>
          <button
            type='button'
            className={`rounded-full bg-[${base}] text-white font-semibold py-3 px-7`}
          >
            Konsultasi Gratis
          </button>
        </a>
      </div>
    </section>
  );
}

export default Consult;
